import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  HostListener
} from "@angular/core";
import {
  Router,
  NavigationEnd,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  ResolveStart,
  ResolveEnd
} from "@angular/router";
import { Subscription } from "rxjs";
import { MatSidenav } from "@angular/material/sidenav";
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import { ThemeService } from "../../../services/theme.service";
import PerfectScrollbar from 'perfect-scrollbar';
import { LayoutService } from "../../../services/layout.service";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html"
})
export class AuthLayoutComponent implements OnInit {
  public isModuleLoading: Boolean = false;
  private layoutConfSub: Subscription;
  private routerEventSub: Subscription;
  private mediaSub: Subscription;

  public scrollConfig = {};
  public layoutConf: any = {};

  constructor(
    private router: Router,
    public themeService: ThemeService,
    private layout: LayoutService,
    private media: MediaObserver
  ) {
    // Close sidenav after route change in mobile
    this.routerEventSub = router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((routeChange: NavigationEnd) => {
        this.layout.adjustLayout({ route: routeChange.url });
      });
    this.layout.publishLayoutChange({
      sidebarStyle: "closed"
    });
  }
  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.layout.adjustLayout(event);
  }

  ngAfterViewInit() {
    // this.layoutConfSub = this.layout.layoutConf$.subscribe(change => {
    //   // this.initBodyPS(change)
    // })
  }

  ngOnDestroy() {
    if (this.layoutConfSub) {
      this.layoutConfSub.unsubscribe();
    }
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }
  }
  closeSidebar() {
    this.layout.publishLayoutChange({
      sidebarStyle: "closed"
    });
  }
}
